var that;
import { Dialog } from 'vant';
export default {
    setup() {
        const onClickLeft = () => history.back();
        return {
            onClickLeft,
        };
    },

    data() {
        return {
            memberId: '',
            dhrecordList: []
        };
    },

    created() {
        // that = this;
        // this.memberId = this.$route.query.memberId;
        // console.log(this.memberId);
        // this.getDhrecordList();
    },

    mounted() {
        that = this;
        this.memberId = this.$route.query.memberId;
        console.log(this.memberId);
        this.getDhrecordList();

    },
    methods: {
        // 点击领取地点弹框
        dialogAddress(val) {
            Dialog({
                title: '领取地点',
                message: val.receiveMethod,
                theme: 'round-button',
            }).then(() => {
                // on close
                // location.reload();
            });
        },
        // 列表接口
        getDhrecordList() {
            this.$api.getDhrecordList({
                params: {
                    memberId: this.$route.query.memberId,
                },
                success: function(res) {
                    console.log("resres1111", res);
                    that.dhrecordList = res.data
                }
            })
        },
        comfirm(dhRecordId) {
            let that = this;
            Dialog({
                    title: '确认领取',
                    message: '如您已确认领取到物品后，请点击"确认"，如未领取请点击"取消"。\n' +
                        '(注意：请在工作人员指导下现场点击“确认”，完成核销。)',
                    theme: 'round-button',
                    showCancelButton: true
                }).then(() => {
                    // on close
                    that.getWriteOff(dhRecordId)

                })
                .catch(() => {
                    // on cancel
                    // console.log('// on cancel');
                });
        },
        // 用户自主核销
        getWriteOff(dhRecordId) {
            this.$api.getWriteOff({
                params: {
                    memberId: this.$route.query.memberId,
                    dhRecordId: dhRecordId,
                },
                success: function(res) {
                    console.log("122", res);
                    if (res.code == 0) {
                        location.reload();
                    }
                }
            })
        }
    }
};